import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "customer" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "Developments", -1)
const _hoisted_3 = {
  key: 0,
  class: "col-sm-8"
}
const _hoisted_4 = { class: "table table-hover" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Name"),
  /*#__PURE__*/_createElementVNode("th", null, "Branch"),
  /*#__PURE__*/_createElementVNode("th")
], -1)
const _hoisted_6 = { class: "text-right" }
const _hoisted_7 = {
  class: "btn-group",
  role: "group",
  "aria-label": "Actions"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-1" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-outline-primary",
    "data-toggle": "modal",
    "data-target": "#add-establishment-modal"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" })
  ])
], -1)

import _ from "lodash";
import { computed } from 'vue';
import { useStore } from 'vuex';
import { Customer } from "@/models";
import AddEstablishmentModal from "@/components/modals/AddEstablishmentModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Establishments',
  setup(__props) {

const store = useStore();

const customer = computed(() => store.getters['customers/current']);
const removeEstablishment = async (establishment: Customer) => await store.dispatch('customers/removeEstablishment', establishment);
const establishments = computed(() => {
  return customer.value.establishments;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (establishments.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("table", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(establishments.value, (est, $index) => {
                return (_openBlock(), _createElementBlock("tr", { key: $index }, [
                  _createElementVNode("td", null, _toDisplayString(est.companyName), 1),
                  _createElementVNode("td", null, _toDisplayString(est.branchName), 1),
                  _createElementVNode("td", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("button", {
                        class: "btn btn-outline-danger",
                        onClick: ($event: any) => (removeEstablishment(est))
                      }, _hoisted_10, 8, _hoisted_8)
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_11,
    _createVNode(AddEstablishmentModal)
  ]))
}
}

})